import axios from 'axios';

const instance = axios.create({
    baseURL:process.env.REACT_APP_API_BASE_URL
});
instance.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("authenticated_token");
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default instance;